// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0a790aab","453":"ab1e9c8e","455":"e7871437"}[chunkId] + ".chunk.js";
};